export const projekte = [
  {
    id: 'aufstockung-kondominium-meran',
    title: 'Aufstockung Kondominium Meran',
    ort: 'Meran, Südtirol',
    kategorie: 'Aufstockung',
    jahr: '2026',
    image: '/assets/fotos/hb-kondominium-meran-1.webp',
    images: [
      '/assets/fotos/hb-kondominium-meran-1.webp',
      '/assets/fotos/hb-kondominium-meran-2.webp',
      '/assets/fotos/hb-kondominium-meran-3.webp',
      '/assets/fotos/hb-kondominium-meran-4.webp',
    ],
    kurztext: 'Aufstockung eines Kondominiums in Meran in Holzbauweise – neues Dachgeschoss mit großzügigen Wohneinheiten und Außenterrassen.',
    herausforderung: 'Die Aufstockung musste bei laufendem Wohnbetrieb realisiert werden. Statische Integration der Holzkonstruktion in das bestehende Betongebäude unter Einhaltung aller Sicherheits- und Lärmschutzauflagen.',
    loesung: 'Vollständige Vorfertigung aller Holzelemente im Werk. Kran-Montage der einzelnen Wandmodule – Rohbau in wenigen Tagen, minimale Beeinträchtigung der Bewohner.',
    ergebnis: 'Neues Dachgeschoss mit mehreren Wohneinheiten und Außenterrassen. Hochwertige Holzkonstruktion, architektonisch in die Bestandsfassade integriert.',
    leistungen: ['Aufstockung', 'Holzrahmenbau', 'Deckenträger', 'Holzfassade', 'Terrassen', 'Innenausbau'],
    tags: ['Aufstockung'],
    it: {
      title: 'Sopraelevazione Condominio Merano',
      kurztext: 'Sopraelevazione di un condominio a Merano in costruzione in legno – nuovo piano mansardato con ampie unità abitative e terrazze esterne.',
      herausforderung: 'La sopraelevazione doveva essere realizzata con i residenti presenti. Integrazione statica della costruzione in legno nell\'edificio in cemento esistente nel rispetto di tutte le norme di sicurezza e rumore.',
      loesung: 'Prefabbricazione completa di tutti gli elementi in legno in officina. Montaggio con gru dei singoli moduli parietali – struttura completata in pochi giorni, disagio minimo per i residenti.',
      ergebnis: 'Nuovo piano mansardato con più unità abitative e terrazze esterne. Costruzione in legno di pregio, integrata architettonicamente nella facciata esistente.',
      leistungen: ['Sopraelevazione', 'Sistema a telaio in legno', 'Travi del solaio', 'Facciata in legno', 'Terrazze', 'Rifinitura interna']
    }
  },
  {
    id: 'fassadenverkleidung-hotel-partschins',
    title: 'Fassadenverkleidung Hotel Partschins',
    ort: 'Partschins, Südtirol',
    kategorie: 'Holzfassaden',
    jahr: '2026',
    image: '/assets/fotos/hb-foto-3.webp',
    images: ['/assets/fotos/hb-foto-3.webp', '/assets/fotos/hb-foto-9.webp', '/assets/fotos/hb-foto-4.webp'],
    kurztext: 'Vollständige Holzfassadenverkleidung eines Hotels in Partschins – Lärchenholz naturbelassen, präzise gefügt, langlebig.',
    herausforderung: 'Fassadenarbeiten an einem laufenden Hotelbetrieb in der Hauptsaison mit engen Zeitfenstern und hohen Qualitätsanforderungen an Maßhaltigkeit und Oberfläche.',
    loesung: 'Modulare Vorfertigung der Fassadenelemente im Werk. Montage in definierten Abschnitten ohne Betriebsunterbrechung. Verwendung von heimischer Lärche aus regionaler Forstwirtschaft.',
    ergebnis: 'Hochwertige Holzfassade, die dem Hotel ein modernes, alpines Erscheinungsbild verleiht. Langlebig, wartungsarm, regional verankert.',
    leistungen: ['Holzfassade', 'Lärchenholz', 'Unterkonstruktion', 'Wärmedämmung', 'Montage'],
    tags: ['Holzfassaden'],
    it: {
      title: 'Rivestimento Facciata Hotel Parcines',
      kurztext: 'Rivestimento completo in legno della facciata di un hotel a Parcines – larice naturale, lavorato con precisione, durevole.',
      herausforderung: 'Lavori di facciata su un hotel attivo durante la stagione principale, con finestre temporali ristrette e requisiti elevati di precisione dimensionale e finitura superficiale.',
      loesung: 'Prefabbricazione modulare degli elementi di facciata in officina. Montaggio per sezioni definite senza interruzione dell\'attività. Utilizzo di larice locale da silvicoltura regionale.',
      ergebnis: 'Facciata in legno di pregio che conferisce all\'hotel un aspetto alpino moderno. Durevole, con bassa manutenzione, radicato nel territorio.',
      leistungen: ['Facciata in legno', 'Larice', 'Struttura di supporto', 'Isolamento termico', 'Montaggio']
    }
  },
  {
    id: 'almhuette-hafling',
    title: 'Almhütte Hafling',
    ort: 'Hafling, Südtirol',
    kategorie: 'Aufstockung',
    jahr: '2026',
    image: '/assets/fotos/hb-foto-10.webp',
    images: ['/assets/fotos/hb-foto-10.webp', '/assets/fotos/hb-foto-11.webp', '/assets/fotos/hb-foto-1.webp'],
    kurztext: 'Aufstockung und Erweiterung einer Almhütte in Hafling in traditioneller Blockbauweise – präzise Handwerksarbeit, alpine Materialien.',
    herausforderung: 'Erweiterung einer bestehenden Almhütte im alpinen Gelände unter Einhaltung der traditionellen Blockbauweise. Materialtransport in schwer zugänglichem Gelände, kurzes Baufenster.',
    loesung: 'Vorfertigung der Blockbau-Elemente im Werk, Transport und Montage in einem kompakten Zeitraum. Verwendung von massivem heimischen Holz, präzise auf Maß gearbeitet.',
    ergebnis: 'Erweiterte Almhütte mit zusätzlichem Geschoss – authentisch, massiv, langlebig. Traditionelle Blockbauweise mit modernem Komfort im Inneren.',
    leistungen: ['Blockbau', 'Aufstockung', 'Dachstuhl', 'Zimmermannsarbeiten', 'Innenausbau'],
    tags: ['Aufstockung'],
    it: {
      title: 'Maso Alpino Avelengo',
      kurztext: 'Sopraelevazione e ampliamento di un maso alpino ad Avelengo in tradizionale costruzione a blockbau – lavorazione artigianale precisa, materiali alpini.',
      herausforderung: 'Ampliamento di un maso alpino in terreno montano nel rispetto della tradizionale costruzione a blockbau. Trasporto dei materiali in territorio difficilmente accessibile, breve finestra di costruzione.',
      loesung: 'Prefabbricazione degli elementi blockbau in officina, trasporto e montaggio in un periodo compatto. Utilizzo di legno massiccio locale, lavorato con precisione su misura.',
      ergebnis: 'Maso ampliato con piano aggiuntivo – autentico, massiccio, durevole. Costruzione blockbau tradizionale con comfort moderno all\'interno.',
      leistungen: ['Blockbau', 'Sopraelevazione', 'Struttura del tetto', 'Lavori da falegname', 'Rifinitura interna']
    }
  },
  {
    id: 'camping-sonnenberg-partschins',
    title: 'Camping am Sonnenberg',
    ort: 'Partschins, Südtirol',
    kategorie: 'Hotelbau',
    jahr: '2025',
    image: 'https://hafner-ec.com/wp-content/uploads/2025/08/Hafner-Bauunternehmen-Baufirma-Meran-Camping-Partschins-18-DSCF1377-2000.jpg',
    images: [
      'https://hafner-ec.com/wp-content/uploads/2025/08/Hafner-Bauunternehmen-Baufirma-Meran-Camping-Partschins-18-DSCF1377-2000.jpg',
      'https://hafner-ec.com/wp-content/uploads/2025/02/Camping-Meran-Baufirma-Hafner-Schluesselfertig-1.jpg',
      '/assets/fotos/hb-foto-k5.webp',
      '/assets/fotos/hb-foto-k1.webp'
    ],
    kurztext: 'Hochwertiger Camping-Holzbau mit Lodges und Gemeinschaftsbauten im Naturpark.',
    herausforderung: 'Realisierung hochwertiger Unterkünfte und Gemeinschaftsgebäude in sensibler Naturschutzlage – mit kürzester Bauzeit und maximaler Schonung des Geländes.',
    loesung: 'Konsequenter Einsatz von Holzmodulen und vorgefertigten Elementen. Alle Bauteile wurden im Werk fertiggestellt und auf der Baustelle montiert – minimaler Eingriff, maximale Qualität.',
    ergebnis: 'Fertigstellung innerhalb einer Saison. Hochwertige Atmosphäre, die dem natürlichen Umfeld gerecht wird.',
    leistungen: ['Tragwerk', 'Fassade', 'Dachstuhl', 'Innenausbau in Holz'],
    tags: ['Hotelbau', 'Aufstockung'],
    it: {
      title: 'Camping am Sonnenberg',
      kurztext: 'Costruzione in legno di pregio per un campeggio con lodges e edifici comuni nel parco naturale.',
      herausforderung: 'Realizzazione di alloggi di pregio e edifici comuni in un\'area naturale protetta – con i più brevi tempi di costruzione e il massimo rispetto del terreno.',
      loesung: 'Uso sistematico di moduli in legno ed elementi prefabbricati. Tutti i componenti sono stati completati in officina e montati in cantiere – intervento minimo, qualità massima.',
      ergebnis: 'Completamento nell\'arco di una stagione. Atmosfera di pregio in armonia con l\'ambiente naturale.',
      leistungen: ['Struttura portante', 'Facciata', 'Struttura del tetto', 'Rifinitura interna in legno']
    }
  },
  {
    id: 'kohlbrenner-lodges-moelten',
    title: 'Kohlbrenner Lodges',
    ort: 'Mölten, Südtirol',
    kategorie: 'Hotelbau',
    jahr: '2024',
    image: '/assets/fotos/hb-foto-k3.webp',
    images: [
      '/assets/fotos/hb-foto-k3.webp',
      '/assets/fotos/hb-foto-k4.webp',
      '/assets/fotos/hb-foto-k5.webp',
      '/assets/fotos/hb-foto-k2.webp',
      '/assets/fotos/hb-foto-k1.webp',
      'https://hafner-ec.com/wp-content/uploads/2025/04/Kohlbrenner-99-2500.jpg',
    ],
    kurztext: 'Exklusive Holz-Lodges in alpiner Lage – präzise Planung und schnelle Ausführung.',
    herausforderung: 'Exklusiver Lodgebau in exponierter Höhenlage mit komplexen Anforderungen an Wärmeschutz, Witterungsbeständigkeit und Ästhetik.',
    loesung: 'Massive Holzkonstruktionen mit optimaler Dämmung, hochwertigen Holzfassaden und individuell gestalteten Innenräumen.',
    ergebnis: 'Einzigartige Ferienanlage, die Premium-Urlauber anzieht und in der Region für Aufsehen sorgt.',
    leistungen: ['Holzkonstruktion', 'Holzfassaden', 'Dachkonstruktion', 'Terrassen'],
    tags: ['Hotelbau', 'Holzfassaden', 'Dachstuhl'],
    it: {
      title: 'Kohlbrenner Lodges',
      kurztext: 'Lodges in legno esclusive in posizione alpina – pianificazione precisa e realizzazione rapida.',
      herausforderung: 'Costruzione di lodges esclusive in quota esposta con requisiti complessi di protezione termica, resistenza agli agenti atmosferici ed estetica.',
      loesung: 'Costruzioni massive in legno con isolamento ottimale, facciate in legno di pregio e interni progettati individualmente.',
      ergebnis: 'Un resort vacanze unico che attira ospiti premium e fa parlare di sé nella regione.',
      leistungen: ['Costruzione in legno', 'Facciate in legno', 'Struttura del tetto', 'Terrazze']
    }
  },
  {
    id: 'live-merano-camping',
    title: 'live merano camping',
    ort: 'Meran, Südtirol',
    kategorie: 'Hotelbau',
    jahr: '2025',
    image: 'https://hafner-ec.com/wp-content/uploads/2025/02/Camping-Meran-Baufirma-Hafner-Schluesselfertig-1.jpg',
    images: ['https://hafner-ec.com/wp-content/uploads/2025/02/Camping-Meran-Baufirma-Hafner-Schluesselfertig-1.jpg'],
    kurztext: 'Schlüsselfertiger Campingbau mit Holzelementen in modernem Design.',
    herausforderung: 'Realisierung moderner Campingunterkünfte mit Premium-Charakter und wirtschaftlichem Baubudget.',
    loesung: 'Standardisierte Holzmodule mit individueller Gestaltung – effizient in der Herstellung, hochwertig im Ergebnis.',
    ergebnis: 'Saisongerechte Fertigstellung, begeisterte Gäste.',
    leistungen: ['Modulbau', 'Holzfassaden', 'Dachkonstruktion'],
    tags: ['Hotelbau', 'Holzfassaden'],
    it: {
      title: 'live merano camping',
      kurztext: 'Costruzione di campeggio chiavi in mano con elementi in legno in design moderno.',
      herausforderung: 'Realizzazione di strutture ricettive per campeggio di carattere premium con budget edilizio economico.',
      loesung: 'Moduli in legno standardizzati con design individuale – efficienti nella produzione, di pregio nel risultato.',
      ergebnis: 'Completamento nei tempi stagionali, ospiti entusiasti.',
      leistungen: ['Edilizia modulare', 'Facciate in legno', 'Struttura del tetto']
    }
  },
  {
    id: 'industriehalle-siebenfoercher',
    title: 'Industriehalle Siebenförcher',
    ort: 'Südtirol',
    kategorie: 'Gewerbe',
    jahr: '2024',
    image: '/assets/fotos/hb-foto-2-3.webp',
    images: ['/assets/fotos/hb-foto-2-3.webp', '/assets/fotos/hb-foto-3.webp'],
    kurztext: 'Neubau einer Industriehalle für das Unternehmen Siebenförcher – Holztragwerk, Fassade und Dachkonstruktion.',
    herausforderung: 'Errichtung einer großflächigen Industriehalle in Holzbauweise mit hohen Anforderungen an Tragsicherheit, Brandschutz und Fertigstellungstermin.',
    loesung: 'Holz-Leimtragwerk mit BSH-Bindern, vorgefertigte Wandelemente und präzise abgestimmter Montageplan für einen reibungslosen Bauablauf.',
    ergebnis: 'Fertigstellung im vorgesehenen Terminrahmen. Energieeffiziente und repräsentative Halle mit langlebiger Holzkonstruktion.',
    leistungen: ['Hallentragwerk', 'BSH-Binder', 'Holzfassade', 'Dachkonstruktion'],
    tags: ['Gewerbe'],
    it: {
      title: 'Capannone Industriale Siebenförcher',
      kurztext: 'Nuova costruzione di un capannone industriale per l\'azienda Siebenförcher – struttura portante in legno, facciata e struttura del tetto.',
      herausforderung: 'Realizzazione di un capannone industriale di grandi dimensioni in costruzione lignea con elevati requisiti di sicurezza strutturale, protezione antincendio e termine di completamento.',
      loesung: 'Struttura portante in legno lamellare con travi BSH, elementi parietali prefabbricati e piano di montaggio coordinato con precisione per un processo costruttivo senza intoppi.',
      ergebnis: 'Completamento nel termine previsto. Capannone energeticamente efficiente e rappresentativo con struttura in legno di lunga durata.',
      leistungen: ['Struttura portante', 'Travi BSH', 'Facciata in legno', 'Struttura del tetto']
    }
  },
  {
    id: 'hofstelle-tscherms',
    title: 'Hofstelle Tscherms',
    ort: 'Tscherms, Südtirol',
    kategorie: 'Sanierung',
    jahr: '2024',
    image: '/assets/fotos/hb-foto-8-1.webp',
    images: ['/assets/fotos/hb-foto-8-1.webp', '/assets/fotos/hb-foto-2-1.webp', '/assets/fotos/hb-foto-6.webp', '/assets/fotos/hb-foto-3-1.webp'],
    kurztext: 'Abbruch und Wiederaufbau einer historischen Hofstelle in Tscherms – Holzbau mit zeitgemäßer Architektur.',
    herausforderung: 'Die bestehende Hofstelle war baulich nicht sanierbar. Ziel war ein Neubau im Geiste des Bestands – ortstypisch, handwerklich hochwertig und energetisch auf dem neuesten Stand.',
    loesung: 'Vollständiger Abbruch und Wiederaufbau in Holzrahmenbauweise mit Lärchenholzfassade. Neues Volumen, das sich respektvoll in die Umgebung einfügt.',
    ergebnis: 'Authentisch wirkender Neubau mit modernem Energiestandard – Klimahaus A zertifiziert.',
    leistungen: ['Holzrahmenbau', 'Holzfassade', 'Dachstuhl', 'Terrassen'],
    tags: ['Sanierung', 'Holzfassaden', 'Holzhaus'],
    it: {
      title: 'Maso Tscherms',
      kurztext: 'Demolizione e ricostruzione di un maso storico a Tscherms – costruzione in legno con architettura contemporanea.',
      herausforderung: 'Il maso esistente non era risanabile dal punto di vista edilizio. L\'obiettivo era una nuova costruzione nello spirito del patrimonio esistente – tipica del luogo, artigianalmente di pregio e con i più recenti standard energetici.',
      loesung: 'Demolizione completa e ricostruzione in sistema a telaio in legno con facciata in legno di larice. Nuovo volume che si inserisce rispettosamente nel contesto.',
      ergebnis: 'Nuova costruzione dall\'aspetto autentico con moderni standard energetici – certificato KlimaHaus A.',
      leistungen: ['Sistema a telaio in legno', 'Facciata in legno', 'Struttura del tetto', 'Terrazze']
    }
  },
  {
    id: 'aufstockung-meran',
    title: 'Aufstockung Meran',
    ort: 'Meran, Südtirol',
    kategorie: 'Aufstockung',
    jahr: '2024',
    image: '/assets/fotos/hb-foto-1-1.webp',
    images: ['/assets/fotos/hb-foto-1-1.webp', '/assets/fotos/hb-foto-7.webp', '/assets/fotos/hb-foto-9.webp'],
    kurztext: 'Aufstockung eines Bestandsgebäudes in Meran mit neuem Vollgeschoss und hochwertiger Holzfassadenverkleidung.',
    herausforderung: 'Das Bestandsgebäude sollte um ein vollwertiges Wohngeschoss aufgestockt und gleichzeitig mit einer neuen Fassade optisch erneuert werden – alles in bewohntem Zustand.',
    loesung: 'Leichte Holzrahmenkonstruktion für die Aufstockung kombiniert mit einer hinterlüfteten Lärchenholzfassade über alle Geschosse. Kurze Montagezeit, minimale Beeinträchtigung.',
    ergebnis: 'Neues Wohngeschoss und vollständig erneuertes Erscheinungsbild in wenigen Wochen Bauzeit. Klimahaus-Standard erreicht.',
    leistungen: ['Aufstockung', 'Holzfassade', 'Dämmung', 'Dachkonstruktion'],
    tags: ['Aufstockung', 'Holzfassaden'],
    it: {
      title: 'Sopraelevazione Merano',
      kurztext: 'Sopraelevazione di un edificio esistente a Merano con un nuovo piano completo e rivestimento di facciata in legno di pregio.',
      herausforderung: 'L\'edificio esistente doveva essere sopraelevato di un piano abitativo completo e allo stesso tempo rinnovato visivamente con una nuova facciata – tutto in stato di abitazione.',
      loesung: 'Leggera costruzione a telaio in legno per la sopraelevazione combinata con una facciata ventilata in legno di larice su tutti i piani. Breve tempo di montaggio, minimo disagio.',
      ergebnis: 'Nuovo piano abitativo e aspetto completamente rinnovato in poche settimane di costruzione. Raggiunto lo standard KlimaHaus.',
      leistungen: ['Sopraelevazione', 'Facciata in legno', 'Isolamento', 'Struttura del tetto']
    }
  },
  {
    id: 'haus-haas-montan',
    title: 'Haus Haas – Montan',
    ort: 'Montan, Südtirol',
    kategorie: 'Holzhaus',
    jahr: '2023',
    image: 'https://hafner-ec.com/wp-content/uploads/2025/10/Haus-Haas-Wohnung-Montan-Amadeus-Hafner-%C2%A9ArminHuber_low-0328-1000.jpg',
    images: ['https://hafner-ec.com/wp-content/uploads/2025/10/Haus-Haas-Wohnung-Montan-Amadeus-Hafner-%C2%A9ArminHuber_low-0328-1000.jpg'],
    kurztext: 'Neubau Haus Haas in Montan – sämtliche Zimmermannsarbeiten durch Holzbuddy: Dachstuhl, Holzkonstruktion, Fassade und Innenausbau.',
    herausforderung: 'Realisierung aller Holzbauarbeiten im Rahmen eines Neubaus in Montan – enger Terminplan, höchste handwerkliche Präzision gefordert.',
    loesung: 'Holzbuddy übernahm alle Zimmermannsarbeiten: von der Dachkonstruktion über die Holzfassade bis zum hochwertigen Innenausbau – aus einer Hand, termingerecht.',
    ergebnis: 'Hochwertiger Neubau mit durchgängiger Holzqualität. Alle Zimmermannsarbeiten präzise und termingerecht ausgeführt.',
    leistungen: ['Dachstuhl', 'Holzkonstruktion', 'Holzfassade', 'Zimmermannsarbeiten', 'Innenausbau'],
    tags: ['Holzhaus'],
    it: {
      title: 'Casa Haas – Montagna',
      kurztext: 'Nuova costruzione Casa Haas a Montagna – tutti i lavori da falegname eseguiti da Holzbuddy: struttura del tetto, costruzione in legno, facciata e rifinitura interna.',
      herausforderung: 'Realizzazione di tutti i lavori in legno nell\'ambito di una nuova costruzione a Montagna – tempi stretti, massima precisione artigianale richiesta.',
      loesung: 'Holzbuddy ha eseguito tutti i lavori da falegname: dalla struttura del tetto alla facciata in legno fino alla rifinitura interna di pregio – tutto da un\'unica fonte, nei tempi previsti.',
      ergebnis: 'Nuova costruzione di pregio con qualità del legno uniforme. Tutti i lavori da falegname eseguiti con precisione e nei tempi.',
      leistungen: ['Struttura del tetto', 'Costruzione in legno', 'Facciata in legno', 'Lavori da falegname', 'Rifinitura interna']
    }
  },
  {
    id: 'wirtschaftsgebaeude-moelten',
    title: 'Wirtschaftsgebäude Mölten',
    ort: 'Mölten, Südtirol',
    kategorie: 'Gewerbe',
    jahr: '2023',
    image: '/assets/fotos/hb-foto-2.webp',
    images: ['/assets/fotos/hb-foto-2.webp', '/assets/fotos/hb-foto-12.webp'],
    kurztext: 'Neubau eines landwirtschaftlichen Stalls und Wirtschaftsgebäudes in Mölten – solide Holzkonstruktion, sauber ausgeführt.',
    herausforderung: 'Errichtung eines dauerhaften landwirtschaftlichen Wirtschaftsgebäudes unter anspruchsvollen Bedingungen in Hanglage und mit strikten Fristen vor der Saison.',
    loesung: 'Holz-Leimtragwerk mit großzügigen Öffnungen für Belichtung und Belüftung. Vorfertigung aller Elemente für kurze Montagezeit auf der Baustelle.',
    ergebnis: 'Fertiggestellt vor Saisonbeginn. Robuste, langlebige Konstruktion – handwerklich sauber ausgeführt.',
    leistungen: ['Hallentragwerk', 'BSH-Binder', 'Holzfassade', 'Dacheindeckung'],
    tags: ['Gewerbe'],
    it: {
      title: 'Edificio Rurale Mölten',
      kurztext: 'Nuova costruzione di una stalla e di un edificio rurale a Mölten – solida costruzione in legno, realizzata con cura.',
      herausforderung: 'Realizzazione di un edificio rurale duraturo in condizioni impegnative su terreno in pendenza e con scadenze stringenti prima della stagione.',
      loesung: 'Struttura portante in legno lamellare con ampie aperture per illuminazione e ventilazione. Prefabbricazione di tutti gli elementi per brevi tempi di montaggio in cantiere.',
      ergebnis: 'Completato prima dell\'inizio della stagione. Costruzione robusta e duratura – realizzata con cura artigianale.',
      leistungen: ['Struttura portante', 'Travi BSH', 'Facciata in legno', 'Copertura del tetto']
    }
  },
];

export const getProjektById = (id) => projekte.find(p => p.id === id);

export const kategorien = ['Alle', 'Aufstockung', 'Dachstuhl', 'Holzhaus', 'Hotelbau', 'Sanierung', 'Holzfassaden', 'Gewerbe'];
